import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');
require('./printerSelection.less');

class UserHandlingController {
    originalUser;
    private modalInstance;
    printerInside: string;
    printerOutside: string;

    constructor(private toastService, private Users){}
    $onInit: Function = ( () => {
        this.getPrinters(this.originalUser.username);
    });

    getPrinters(username: string) {
        this.Users.getPrinters({username: username}).$promise.then((success) => {
            this.printerInside = success.printerInside;
            this.printerOutside = success.printerOutside;
        }, (error)=>{
            this.toastService.parseError(error);
        });
    }

    save(){
        this.Users.updatePrinters({username: this.originalUser.username}, {printerInside: this.printerInside, printerOutside: this.printerOutside}).$promise.then((success) => {
            this.toastService.showSimpleToast(`Printerene har blitt oppdatert for bruker ${this.originalUser.username}`, 3000);
            this.modalInstance.hide();
        }, (error)=>{
            this.toastService.parseError(error);
        });
    }


    closeModal(){
        this.modalInstance.cancel();
    }
}

class PrinterSelectionOptions implements ng.IComponentOptions {
    controller = 'rkcPrinterSelectionController';
    controllerAs = "c";
    template:any = require('./printerSelection.html');
    bindings: any = {
        originalUser:'=',
        modalInstance:'='
    };
}

rkcApp.controller("rkcPrinterSelectionController", ['toastService','Users',
    function (toastService, Users) {
        return new UserHandlingController(toastService, Users);
    }])
    .component("rkcPrinterSelection", new PrinterSelectionOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/users/printerSelection/printerSelection.ts
 **/